import request from '@/utils/requestMobile'

export function login(data) {
  return request({
    url: '/mobile/user/login',
    method: 'post',
    data
  })
}

export function notAuthLogin(data) {
  return request({
    url: '/mobile/user/not/auth/login',
    method: 'post',
    data
  })
}

export function formLogin(data) {
  return request({
    url: '/mobile/from/user/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/mobile/user/exit',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/mobile/user/info',
    method: 'post',
    data
  })
}

export function userRegister(data) {
  return request({
    url: '/mobile/user/register',
    method: 'post',
    data
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/mobile/user/sms/send/code',
    method: 'post',
    data
  })
}

export function findSmsCode(data) {
  return request({
    url: '/mobile/user/sms/find/code',
    method: 'post',
    data
  })
}

export function userFindPassword(data) {
  return request({
    url: '/mobile/user/password/find/save',
    method: 'post',
    data
  })
}

export function saveOrderData(data) {
  return request({
    url: '/mobile/order/save',
    method: 'post',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/mobile/update/password',
    method: 'post',
    data
  })
}

export function saveUserSetting(data) {
  return request({
    url: '/mobile/user/setting/save',
    method: 'post',
    data
  })
}

export function getUserSetting(data) {
  return request({
    url: '/mobile/user/setting/data',
    method: 'post',
    data
  })
}

export function getLeaveList(data) {
  return request({
    url: '/mobile/leave/list',
    method: 'post',
    data
  })
}

export function getLeaveInit(data) {
  return request({
    url: '/mobile/leave/apply/init',
    method: 'post',
    data
  })
}

export function saveLeave(data) {
  return request({
    url: '/mobile/leave/save',
    method: 'post',
    data
  })
}

export function deleteLeave(data) {
  return request({
    url: '/mobile/leave/delete',
    method: 'post',
    data
  })
}

export function getUserClassTimesList(data) {
  return request({
    url: '/mobile/class/time/list',
    method: 'post',
    data
  })
}

export function getOrderList(data) {
  return request({
    url: '/mobile/order/list',
    method: 'post',
    data
  })
}

export function getOrderDetail(data) {
  return request({
    url: '/mobile/order/detail',
    method: 'post',
    data
  })
}

export function deleteOrder(data) {
  return request({
    url: '/mobile/delete/order',
    method: 'post',
    data
  })
}

export function getGradeTotal(data) {
  return request({
    url: '/mobile/grade/total/list',
    method: 'post',
    data
  })
}

export function getClassCallList(data) {
  return request({
    url: '/mobile/grade/call/list',
    method: 'post',
    data
  })
}

export function getWxConfig(data) {
  return request({
    url: '/mobile/get/wxconfig',
    method: 'post',
    data
  })
}

export function saveVideoOrderData(data) {
  return request({
    url: '/mobile/video/order/save',
    method: 'post',
    data
  })
}

export function getMonthClassTimes(data) {
  return request({
    url: '/mobile/user/month/class/times',
    method: 'post',
    data
  })
}

export function getVideoOrderList(data) {
  return request({
    url: '/mobile/user/video/orders/list',
    method: 'post',
    data
  })
}

export function deleteVideoOrder(data) {
  return request({
    url: '/mobile/user/video/orders/delete',
    method: 'post',
    data
  })
}

export function getSchoolList(data) {
  return request({
    url: '/mobile/school/list',
    method: 'post',
    data
  })
}

export function showTime(data) {
  return request({
    url: '/mobile/appointment/showtime',
    method: 'post',
    data
  })
}

export function appointmentTeacher(data) {
  return request({
    url: '/mobile/appointment/teacher',
    method: 'post',
    data
  })
}

export function saveTeacherTime(data) {
  return request({
    url: '/mobile/appointment/save/teacher/time',
    method: 'post',
    data
  })
}

export function AppointmentClass(data) {
  return request({
    url: '/mobile/appointment/appointmentclass',
    method: 'post',
    data
  })
}

export function QYWechatPost(data) {
  return request({
    url: '/mobile/appointment/qywechatpost',
    method: 'post',
    data
  })
}

export function getVideoDetail(data) {
  return request({
    url: '/mobile/classshow/getvideodetail',
    method: 'post',
    data
  })
}

export function getStudentCouponList(data) {
  return request({
    url: '/mobile/student/coupon/list',
    method: 'post',
    data
  })
}

export function getStudentTeacherList(data) {
  return request({
    url: '/mobile/student/teacher/list',
    method: 'post',
    data
  })
}

export function changeStudentTeacherSort(data) {
  return request({
    url: '/mobile/student/teacher/change/sort',
    method: 'post',
    data
  })
}

export function getTeacherDetail(data) {
  return request({
    url: '/mobile/teacher/detail',
    method: 'post',
    data
  })
}

export function joinStudentTeacher(data) {
  return request({
    url: '/mobile/student/teacher/join',
    method: 'post',
    data
  })
}

export function cancelStudentTeacher(data) {
  return request({
    url: '/mobile/student/teacher/cancel',
    method: 'post',
    data
  })
}

export function getTeacherList(data) {
  return request({
    url: '/mobile/admin/teacher/list',
    method: 'post',
    data
  })
}

export function saveStudentBind(data) {
  return request({
    url: '/mobile/student/user/bind/wechat',
    method: 'post',
    data
  })
}

export function getStudentBindList(data) {
  return request({
    url: '/mobile/student/bind/list',
    method: 'post',
    data
  })
}

export function changeStudentBindDefault(data) {
  return request({
    url: '/mobile/student/bind/default/change',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/mobile/user.js